import {
  SET_USER_DETAILS,
} from '../../constants';

import { IReduxAction } from '../../interfaces';
import { IIndividualProfile, ILeaderProfile } from '../../../services/interfaces';

interface IUserState {
  profile: IIndividualProfile | ILeaderProfile | null;
}

const initState: IUserState = {
  profile: null,
};

export function userReducer(state = initState, action: IReduxAction) {
  switch (action.type) {
    case SET_USER_DETAILS:
      return {
        ...state,
        profile: action.payload,
      };

    default:
      return state;
  }
}
